import apiCall from '../../../../utils/api';
import {ZeroNeetDashboardData, ZeroNeetSurveySlug} from './types';

export const serializeZeroNeetSlug = (s: ZeroNeetSurveySlug) => ({
    key: s.key,
    numerator: s.numerator,
    ...(s.denominator && {denominator: s.denominator}),
    ...(s.operation && {operation: s.operation}),
    ...(s.filter && {filter: s.filter}),
    // self_is_parent: uoaId is always the Progetto's own id, never a child luogo's.
    ...(s.perParentUoa && {per_parent_uoa: 1, self_is_parent: 1}),
    ...(s.perUoaLatest && {per_uoa_latest: 1}),
    ...(s.poolAverage && {pooled_average: 1}),
});

// runPerParentUoa already returns display-ready values — do not scale by 100 again.
export const fetchZeroNeetSlugs = async (
    container: string,
    uoaId: string,
    slugs: ZeroNeetSurveySlug[],
): Promise<ZeroNeetDashboardData> => {
    const res = await apiCall({
        url: `containers/${container}/uoa/${uoaId}/dashboards/fsv`,
        method: 'POST',
        data: {question_slugs: slugs.map(serializeZeroNeetSlug)},
    });

    const result: ZeroNeetDashboardData = {};
    for (const slug of slugs) {
        result[slug.key] = res.data[slug.key] ?? {uoa: 0, average: 0};
    }
    return result;
};
